import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import Grid from '@mui/material/Grid';
import { Button } from '@material-ui/core';
import axios from 'axios';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import { Backdrop, CircularProgress, Typography} from "@mui/material";

import '../css/login.css'

const url = "https://nrbegzvavi.execute-api.us-east-1.amazonaws.com/dev/medicalteam/create";


const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '25ch',
        },
        width: '100%',
    },
    backButton: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}));

 

function getSteps() {
    return ['Datos Personales'];
}

function getStepContent(stepIndex, classes, props, body, handleChange, isEditing) {

    switch (stepIndex) {
      
        case 0:
        return (<div>
            <FormControl className={classes.root}>
                <Grid container className="container">
                    
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cedula</Typography>
                        <TextField
                            id='id'
                            name='id'
                            value={body.id}
                            disabled={isEditing}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Primer Nombre</Typography>
                        <TextField
                            id='firstName'
                            name='firstName'
                            disabled={isEditing}
                            value={body.firstName}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Segundo Nombre</Typography>
                        <TextField
                            id='secondName'
                            name='secondName'
                            disabled={isEditing}
                            value={body.secondName}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Primer Apellido</Typography>
                        <TextField
                            id='lastName'
                            name='lastName'
                            disabled={isEditing}
                            value={body.lastName}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Segundo Apellido</Typography>
                        <TextField
                            id='secondLastName'
                            name='secondLastName'
                            disabled={isEditing}
                            value={body.secondLastName}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                    
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Nuevo Password</Typography>
                        <TextField
                            id='password'
                            name='password'
                            value={body.password}
                            onChange={handleChange}
                            variant='outlined'
                            aria-label="minimum height"
                            />
                    
                    </Grid>

                </Grid>
            </FormControl>
        </div>);
   
      default:
            return 'Unknown stepIndex';
    }
}


function ChangePasswordPersonalTeam(props) {
    const classes = useStyles();
    const [body, setBody] = useState({
        id: props.medical.id,
        firstName: props.medical.firstName,
        secondName: props.medical.secondName,
        lastName: props.medical.lastName,
        secondLastName: props.medical.secondLastName,
        password: props.medical.password,
        cellphone: props.medical.cellphone,
        email: props.medical.email,
        address: props.medical.address,
        specialty: props.medical.specialty,
        rol: props.medical.rol,
        createDate: props.medical.createDate,
        rm: props.medical.rm,
        statusActive: props.medical.statusActive,
        birthday: props.medical.birthday,
    })
    const [activeStep, setActiveStep] = React.useState(0);
    const [openLoader, setOpenLoader] = React.useState(false);
    const isEditing = props.medical.id != "";
    const steps = getSteps();

    const handleChange = e => {
        setBody({
            ...body,
            [e.target.name]: e.target.value
        })
    }

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    return (
        <div>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            <div>{getStepContent(activeStep, classes, props, body, handleChange, isEditing)}</div>


            <div>

                <div>
                    <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={"buttonBack"}>
                        Back
                    </Button>
                    <Button variant="contained" className="buttonNext"
                        color="primary" onClick={() => {

                            if(activeStep === steps.length - 1) {
                                setOpenLoader(true);
                                let medicalTeam = [];
                                medicalTeam.push(body);
                                axios.post(url, medicalTeam).then(response => {
                                
                                setOpenLoader(false);
                                props.changeMenu(0);
                                
                                
                            });
                        } else {
                            handleNext();
                        }
                        }}>
                        {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                </div>
            </div>


            <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={openLoader}>
            <CircularProgress color="inherit" />
        </Backdrop>
        </div>
    );
};

export default ChangePasswordPersonalTeam;